import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout'
import AiLeadsAction from '../../AiLeads/AiLeadsButton/AiLeadsAction'
import Loader from '../../Loader/Loader'
import PeopleSearchResultsTable from './PeopleSearchResultsTable'
import axios from "axios";
import { toast } from "react-toastify";
import { APIUrlOne, APIUrlThree, APIUrlToken, GetUserId } from "../../../Utils/Utils";
import DeepSearchSelectionModal from '../../UniversalDeepSearch/DeepSearchSelectionModal'
const ProspectSearchResults = () => {
    const [loading, setLoading] = useState(false)
    const [archiveRecord, setArchiveRecord] = React.useState(false)
    const [trackRecord, setTrackRecord] = React.useState(false)
    const [isSalesForceTrigger, setIsSalesForceTrigger] = useState(false);
    const [showSalesForce, setShowSalesForce] = useState(false)
    const [trackingData, setTrackingData] = useState([]);
    const [disableTracking, setDisableTracking] = useState(false);
    const [selectedProspects, setSelectedProspects] = useState([])
    const [isDecisionMakerExcel, setIsDecisionMakerExcel] = useState(false);
    const [totalCount, setTotalCount] = React.useState(0)
    const [addToFav, setAddToFav] = useState(false)
    const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
    const [disableRequestUpdate, setDisableRequestUpdate] = useState(false);
       useEffect(() => {
        localStorage.removeItem("cns")
        localStorage.removeItem("cip")
        localStorage.removeItem("cdp")
    }, [])
    const handleTrackingdata = () => {
        setLoading(true);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                const data = e?.data?.data;
                setTrackingData(data)
            })
            .catch((err) => { });
    };
    useEffect(() => {
        handleTrackingdata();
    }, []);
    useEffect(() => {
        if (trackingData.length > 0 && selectedProspects.length > 0) {
            const isMatching = trackingData.some((trackingItem) =>
                selectedProspects.every(
                    (selectedItem) => Number(selectedItem.person_id) === Number(trackingItem.person_id)
                )
            );
            setDisableTracking(isMatching);
        } else {
            setDisableTracking(false);
        }
    }, [trackingData, selectedProspects]);
    //Universal Deep Search
    const [openSelectionModal, setOpenSelectionModal] = useState(false)
    return (
        <>
            <Layout>
                {loading ? <Loader /> : null}
                <div className="child-section-of-everypage  ">
                    <div style={{ display: "flex" }}>
                        <div>
                            <AiLeadsAction
                                disableTracking={disableTracking}
                                setIsSalesForceTrigger={setIsSalesForceTrigger}
                                isSalesForceTrigger={isSalesForceTrigger}
                                archiveRecord={archiveRecord}
                                setArchiveRecord={setArchiveRecord}
                                setTrackRecord={setTrackRecord}
                                setAddToFav={setAddToFav}
                                showSalesForce={showSalesForce}
                                setRequestUpdateRecord={setRequestUpdateRecord}
                                disableRequestUpdate={disableRequestUpdate}
                                setIsDecisionMakerExcel={setIsDecisionMakerExcel} />
                        </div>
                    </div>
                    <div style={{ padding: "60px 0px 10px 4px" }}>
                        <p className='psr-block'>
                            Below is a list of people related to your search inquiry
                        </p>
                        <p className='psr-block-red'>
                            Unable to find an organization or prospect? <span onClick={() => setOpenSelectionModal(true)}>Click Here to do a Deep Search</span>
                        </p>
                    </div>
                    <div className='psr-block-red psr-records'>Showing {totalCount} results</div>
                    <h3 className='psr-head'>People</h3>
                    <PeopleSearchResultsTable
                        handleTrackingdata={handleTrackingdata}
                        trackingData={trackingData}
                        setIsSalesForceTrigger={setIsSalesForceTrigger}
                        isSalesForceTrigger={isSalesForceTrigger}
                        loading={loading}
                        setLoading={setLoading}
                        archiveRecord={archiveRecord}
                        setArchiveRecord={setArchiveRecord}
                        trackRecord={trackRecord} setTrackRecord={setTrackRecord}
                        selectedOuterRows={selectedProspects}
                        setSelectedOuterRows={setSelectedProspects}
                        setShowSalesForce={setShowSalesForce}
                        setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                        isDecisionMakerExcel={isDecisionMakerExcel}
                        requestUpdateRecord={requestUpdateRecord}
                        setRequestUpdateRecord={setRequestUpdateRecord}
                        setDisableRequestUpdate={setDisableRequestUpdate}
                        setAddToFav={setAddToFav}
                        addToFav={addToFav}
                        totalCount={totalCount} setTotalCount={setTotalCount} />
                </div>
            </Layout>
            <DeepSearchSelectionModal openSelectionModal={openSelectionModal} setOpenSelectionModal={setOpenSelectionModal} setLoading={setLoading} />
        </>
    )
}
export default ProspectSearchResults